
import { saInit, saRegisterPage, saTrack } from '@xes/dh-sensor';
import { getClientCommonMessage } from '@/utils/nativeFn'
import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'

const isProduction = process.env.VUE_APP_PREPATH === 'production'
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

let initSucess = false
export interface IXesLog {
    pubBussinessParamsMap: any;
    view: Function;
    track: Function;
    setProfile: Function;
    [attrName: string]: any;
}
export interface ILog {
    view: Function;
    track: Function;
    setProfile: Function;
    [attrName: string]: any;
}
console.log('isProduction: ', isProduction)

// 处理端上数据
const detailNativeData = (res) => {
  initSucess = true
  saRegisterPage({
    pro_name: 'pro_all_in_one',
    biz_name: 'card_tasks',
    tal_id: res?.tal_id || '',
    stu_id: res?.user_id || '',
    version: res?.service_version_name || '',
  })

  console.log('saRegisterPage2', JSON.stringify(res))
}
// 安卓监听消息
 const receiveAndroid = (res) => {
  let androidResult: any = JSON.parse(res)
  if (androidResult.event == 'getData') {
    detailNativeData(androidResult.dataJson)
  }
}
try {
  saInit({
    server_url: isProduction ? 'https://sensorsdata-5.talbrain.com:8080/sa?project=XES_Ebook' : 'http://sensorsdata-5.talbrain.com:8106/sa?project=XES_Ebook_test',
    pro_name: 'pro_all_in_one',
    show_log: false,
    user_id: 0,
    open_fmp: false,
    heart_beat_mode: false
  }).then(spider => {
    // saInit返回的spider对象上带有如下4个接口，业务方可以将spider挂在到Vue.prototype上以供全局访问

  //   // 上报当前页面停留时长
  //   spider.reportPageStay();

  //   // 设置当前页面需要采集曝光时长的模块
  //   spider.reportShowElements([
  //     {
  //       showName: 'avatar',
  //       elementSelector: '#a1',
  //       percent: 20
  //     }
  //   ]);

  //   // 暂停指定模块的采集曝光时长
  //   spider.pauseReportShowElements(['avatar']);

  //   // 恢复所有暂停的曝光时长的采集
  //   spider.resumeReportShowElements();
  }).catch(error => {
    console.error(error);
  });
} catch (error) {
  /* eslint-disable */
  console.log(error);
}
const initCommonParam = () => {
  try {
    if (initSucess) {
      return false
    }
    getClientCommonMessage({}, (res) => {
      initSucess = true
      saRegisterPage({
          pro_name: 'pro_all_in_one',
          biz_name: 'card_tasks',
          tal_id: res?.tal_id || '',
          stu_id: res?.user_id || '',
          version: res?.service_version_name || '',
      })
      console.log('saRegisterPage1', JSON.stringify(res))
    });
    
    mobileNativeSDK.getData((res) => {
      if (!isAndroidApp) {
        detailNativeData(res)
      }
    })
  } catch (error) {
    /* eslint-disable */
    console.log(error);
  }
}

const xesLog = {
    initCommonParam: () => {
      window['$eventBus'].addListener('receiveAndroidMsg', receiveAndroid);
      initCommonParam()
      let initNums = 1
      const timer = setInterval(() => {
        if (initSucess || initNums > 10) {
          clearInterval(timer)
          return
        }
        initNums++
        initCommonParam()
      }, 100)
    },
    view: (event_name, props, callback) => {
        saTrack(event_name, props, callback)
    },
    track: (event_name, props, callback) => {
        saTrack(event_name, props, callback)
    },
}
export { xesLog }